// @flow
import * as React from 'react'

import { colors } from '@toggl/style'

export const IconCaretRight = () => (
  <svg width={10} height={15} viewBox="0 0 10 15">
    <path
      d="M2 2l5.657 5.657m-5.657 6L7.657 8"
      stroke={colors.fadedPurple}
      fill="none"
    />
  </svg>
)
